var map = {
	"./btn-background-black.png": 265,
	"./btn-background-green.png": 266,
	"./delete-purple.png": 1951,
	"./delete-white.png": 1952,
	"./dog-video-bck.png": 267,
	"./dog-video.png": 1953,
	"./fast-betting-btn-purple.png": 1954,
	"./fast-betting-btn.png": 122,
	"./first-dog.png": 1955,
	"./header-babaijebu.png": 268,
	"./hr-blue-btn.png": 1956,
	"./jackpot/winner-overlay.png": 269,
	"./second-dog.png": 1957,
	"./third-dog.png": 1958,
	"./vdh-bck.png": 173,
	"./vdh-progress.png": 270
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1950;


//////////////////
// WEBPACK FOOTER
// ./src/games/dog-racing/img \.(gif|png|jpe?g|svg)$/
// module id = 1950
// module chunks = 7